import type { Category } from '@/types/site';

export const categories: Category[] = [
  {
    id: 'portal',
    name: '综合门户',
    icon: 'ri-apps-2-line',
    description: '汇聚全网热点的综合信息入口，一站了解天下事，覆盖资讯、生活、服务等多元内容。',
  },
  {
    id: 'news',
    name: '新闻资讯',
    icon: 'ri-newspaper-line',
    description: '权威媒体与深度报道聚合，掌握时事动态、财经观察与行业深度内容。',
  },
  {
    id: 'ecommerce',
    name: '电子商务',
    icon: 'ri-shopping-bag-3-line',
    description: '主流购物平台与优选商城入口，涵盖综合电商、垂直商城与品质好物集市。',
  },
  {
    id: 'tech',
    name: '科技数码',
    icon: 'ri-cpu-line',
    description: '极客资讯、前沿科技与数码评测，追踪技术趋势与智能硬件新品。',
  },
  {
    id: 'finance',
    name: '金融财经',
    icon: 'ri-line-chart-line',
    description: '财经智库、市场行情与投资服务，助力企业调研与个人理财决策。',
  },
  {
    id: 'edu',
    name: '教育培训',
    icon: 'ri-graduation-cap-line',
    description: '优质在线课程、知识社区与升学指导，覆盖从兴趣学习到职业提升。',
  },
  {
    id: 'travel',
    name: '旅游出行',
    icon: 'ri-flight-takeoff-line',
    description: '行程规划、酒店预订与目的地攻略，让每一次出行更省心更从容。',
  },
  {
    id: 'life',
    name: '生活服务',
    icon: 'ri-home-smile-2-line',
    description: '同城服务、家政维修与便民生活入口，解决日常吃穿住行各种需求。',
  },
  {
    id: 'health',
    name: '健康医疗',
    icon: 'ri-heart-pulse-line',
    description: '在线问诊、健康科普与养生资讯，提供可信赖的健康管理入口。',
  },
  {
    id: 'tools',
    name: '工具应用',
    icon: 'ri-tools-line',
    description: '在线工具、文档转换与效率应用集合，即开即用提升工作生产力。',
  },
  {
    id: 'jobs',
    name: '求职招聘',
    icon: 'ri-briefcase-4-line',
    description: '招聘平台、人才服务与职场社区，连接求职者与优质用人单位。',
  },
  {
    id: 'entertainment',
    name: '文创娱乐',
    icon: 'ri-movie-2-line',
    description: '影视音乐、阅读社区与潮流文创，丰富你的碎片娱乐时光。',
  },
];